var exports = {
  "V_": "PersonaComposerPill.module__pillContainer___YXBUeE",
  "Uu": "PersonaComposerPill.module__inButtonRow___YXBUeE",
  "s6": "PersonaComposerPill.module__pillButton___YXBUeE",
  "yM": "PersonaComposerPill.module__latched___YXBUeE",
  "R_": "PersonaComposerPill.module__tagMatched___YXBUeE",
  "Kc": "PersonaComposerPill.module__latchBadge___YXBUeE",
};

module.exports = exports;
